<!--
  V 0.1.0 - 2022-10-10
     - cleaned up for linting
     - removed commented out

-->
<template>
  <v-simple-table height="500px" width="400px">
    <template v-slot:default>
      <thead>
        <tr>
          <!--             <th class="text-left">Name</th>
            <th class="text-left">Value</th>
 -->
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in list" :key="item.id">
          <td class="font-weight-bold">{{ item.name }}</td>
          <td style="width: 500px">{{ item.value }}</td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
/* eslint-disable no-plusplus */

class SubGridRow {
  constructor (name, value, id) {
    this.name = name
    this.value = value
    this.id = id
  }
}

export default {
  name: 'TableDetail',

  props: ['clientTableSubHeaders', 'rowItem'],

  data: () => ({
    error: false,
    errorMessage: '. . .',

    list: [],

    errorDebug: null, // this.$debug,
    infoFlag: false,
    isLoading: false,
    testSpinner: false
  }),

  mounted () {
    this.list = []

    let id = 1

    for (const iter in this.clientTableSubHeaders) {
      // console.log(iter)
      const col = this.clientTableSubHeaders[iter]
      // console.log(iter)
      if (typeof col.hide === 'undefined' && col.hide !== true) {
        //  use this coluimn
        if (typeof this.rowItem[col.value] !== 'undefined') {
          // console.log(col.text + ': ' + this.row[col.value])
          const sgr = new SubGridRow(col.text, this.rowItem[col.value], id)
          // onsole.log(sgr)
          this.list.push(sgr)
          id++
        }
      }
    }
  },

  method: {}
}
</script>
